import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import "../layout/Spinner.css";
import { Dropdown } from "semantic-ui-react";
import { useState, useEffect } from "react";
let sportList = null;
const PlayersDropdown = (props) => {
  const [playerOptions, setPlayerOptions] = useState([]);
  const [games, setGames] = useState([]);
  const athletes = props.testimonial ? props.aathletes : props.athletes;

  useEffect(() => {
    if (athletes && athletes.length > 0) {
      setGames(athletes);
    }
  }, [athletes]);

  useEffect(() => {
    setPlayerOptions(
      Object.keys(games)
        .filter((index) => index !== "id")
        .map((keyId, i) => {
          return {
            key: i,
            text: `${games[keyId].firstName} ${games[keyId].lastName}`,
            value: games[keyId].id,
          };
        })
    );
  }, [games]);

  sportList = (
    <Dropdown
      {...props}
      options={playerOptions}
      selection
      fluid
      placeholder={props.placeholder}
      name={props.name}
      onChange={props.onChange}
      search
      defaultValue={props.defaultValue}
    />
  );
  if (!isLoaded(athletes)) {
    return (
      <Dropdown
        loading
        placeholder="Select Name"
        name={props.name}
        {...props}
      />
    );
  } else {
    return sportList;
  }
};

const mapStateToProps = (state) => {
  return {
    athletes: state.firestore.ordered.athletes,
    aathletes: state.firestore.ordered.adminAthletes,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "athletes",
    },
    {
      collection: "adminAthletes",
      orderBy: ["lastName", "asc"],
    },
  ])
)(PlayersDropdown);
